var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useRef, useState } from 'react';
import { styles } from "./styles";
import { VScrollList } from "../common/VScrollList";
import { useScrollCallback } from "./hooks/useScrollCallback";
import { useRootSize } from "./hooks/useRootSize";
import { useGridCoreConfigure } from "./hooks/useGridCoreConfigure";
import { SCROLL_TO_TYPE } from "../common";
import { cn } from "../helpers";
export function createMemoElement(name, render) {
    var result = React.memo(render);
    result.displayName = name;
    return result;
}
export var GridCore = createMemoElement('GridCore', function GridCoreComponent(props) {
    var _a = useRootSize(), ref = _a.ref, size = _a.size;
    var vListApiRef = useRef(null);
    var listBodyRef = useRef(null);
    var headerContainerRef = useRef(null);
    var onScroll = useScrollCallback({ headerRef: headerContainerRef });
    var gridApi = useState(function () {
        return {
            scrollTo: function (index, options) {
                var _a;
                (_a = vListApiRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
                    index: index,
                    type: (options === null || options === void 0 ? void 0 : options.type) || SCROLL_TO_TYPE.top
                });
            }
        };
    })[0];
    var _b = useGridCoreConfigure({
        rootRef: ref,
        bodyRef: listBodyRef,
        idGetter: props.idGetter,
        rootWidth: size.width,
        data: props.data,
        headerContainerRef: headerContainerRef,
        columns: props.columns,
        plugins: props.plugins,
        gridApi: gridApi
    }), rowRenderer = _b.rowRenderer, header = _b.header, rowWidth = _b.rowWidth, rowHeightGetter = _b.rowHeightGetter, containerAddonRenderer = _b.containerAddonRenderer, bodyAddonRenderer = _b.bodyAddonRenderer, subheaderAddonRenderer = _b.subheaderAddonRenderer, hasColumns = _b.hasColumns, rootClassNames = _b.rootClassNames;
    if (!size.width || !size.height) {
        return React.createElement("div", { ref: ref, className: styles.root });
    }
    var hasRows = !!props.data.length && hasColumns;
    return (React.createElement("div", { ref: ref, className: cn.apply(void 0, __spreadArrays(['vm-GridCore', styles.root], rootClassNames)) },
        header,
        React.createElement("div", { className: styles.body, style: { minWidth: size.width } },
            hasRows && subheaderAddonRenderer(),
            hasRows && (React.createElement(VScrollList, { apiRef: vListApiRef, bodyRef: listBodyRef, rowHeightGetter: rowHeightGetter, totalCount: props.data.length, rowRenderer: rowRenderer, rowsLimit: 100, rowWidth: rowWidth, onScroll: onScroll })),
            bodyAddonRenderer()),
        hasRows && props.footer,
        containerAddonRenderer()));
});
//# sourceMappingURL=GridCore.js.map